import useTestId from '@ori/testid-generator';
import type { FC } from 'react';
import React, { useCallback, useState } from 'react';

import { useAppContext } from '../../contexts';
import { useTranslations } from '../../hooks';
import { BackInStockNotificationChannel } from '../../models';
import { NOTIFY_TYPE } from './constants';
import { Root } from './styles';
import type { NotifyTypeProps } from './types';

export const NotifyType: FC<NotifyTypeProps> = ({ currentType, onChange }) => {
  const { getTestId } = useTestId();
  const { config } = useAppContext();
  const { translations } = useTranslations();
  const [isSelected, setIsSelected] = useState(currentType !== BackInStockNotificationChannel.Email);

  const handleChange = useCallback(
    ({ currentTarget: { checked } }: React.ChangeEvent<HTMLInputElement>) => {
      setIsSelected(checked);
      onChange(checked ? BackInStockNotificationChannel.Sms : BackInStockNotificationChannel.Email);
    },
    [onChange],
  );

  if (!config?.smsSubscriptionEnabled) {
    return null;
  }

  return (
    <Root
      fullWidth
      data-testid={getTestId(NOTIFY_TYPE)}
      checked={isSelected}
      firstText={translations.email}
      secondText={translations.sms}
      role="radiogroup"
      onChange={handleChange}
    />
  );
};
